import { useCallback, useEffect, useState } from 'react';
import {
  preRequest,
  requestBooking,
  resetPreRequest,
  selectPreRequest,
} from '@pharmaplan/common';
import { useAppSelector } from '../useAppSelector';
import { useAppDispatch } from '../useAppDispatch';
import usePreRequestUtils from './usePreRequestUtils';

const usePreRequest = () => {
  const dispatch = useAppDispatch();

  const [params, setParams] = useState({
    id: '',
    isAutoSyncRecord: false,
    isLongTerm: false,
  });
  const { id, isAutoSyncRecord } = params ?? {};

  const preRequestStatus = useAppSelector(selectPreRequest);
  const { isSufficientSoftwareKnowledge } = preRequestStatus ?? {};

  const { showSoftwareWarning } = usePreRequestUtils();

  const runSoftwareCheck = useCallback(() => {
    if (id) {
      if (isSufficientSoftwareKnowledge === false) {
        showSoftwareWarning();
      } else if (isSufficientSoftwareKnowledge === true) {
        dispatch(requestBooking({ workshiftid: id, isAutoSyncRecord }));
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSufficientSoftwareKnowledge]);

  useEffect(() => {
    if (!params?.isLongTerm) {
      runSoftwareCheck();
      dispatch(resetPreRequest());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSufficientSoftwareKnowledge]);

  const preRequestBooking = (
    workshiftId: string,
    isLongTerm: boolean,
    _isAutoSyncRecord?: boolean,
  ) => {
    setParams({
      id: workshiftId,
      isAutoSyncRecord: !!_isAutoSyncRecord,
      isLongTerm,
    });

    dispatch(
      preRequest({
        workshiftid: workshiftId,
        isAutoSyncRecord: _isAutoSyncRecord,
      }),
    );
  };

  return { preRequestBooking };
};

export default usePreRequest;
